import http from '@/http'
const URL = '/admin/videos'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const saveVideo = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}
export const changeStatus = (payload) => http.put(URL + `/${payload}/status`)

export const orderList = async (payload) => http.put(URL + `/sequence`, payload)

export const deleteVideo = async (id) => http.delete(URL + `/${id}`)

export default {
  list,
  show,
  orderList,
  saveVideo,
  changeStatus,
  deleteVideo
}
